import { analyzerDate, includeProviders, lengthRental, repricingPass } from "@signals"
import { passDecisions, showPassDecisions } from "Pages/AnalyzersV2/@signals"
import { cellDecisions, indexDecisions } from "../@services/cellDecisions"

// one index per answer and row mode, not one per cell
let cache = { response: null, index: null }

export function decisionsIndex() {
	const response = passDecisions.value
	if (cache.response !== response) cache = { response, index: indexDecisions(response) }
	return cache.index
}

const single = value => Array.isArray(value) ? (value.length === 1 ? value[0] : null) : value

/** The cell's place: its site (and provider in Web & Provider), its date and its length. DOR has one length, LOR one
 *  date: the axis the row does not carry comes from the filters. */
export function cellPlace(priceData) {
	return {
		site: priceData?.id_site,
		provider: priceData?.id_master_provider,
		date: priceData?.pickup_date ?? single(analyzerDate.value),
		lor: priceData?.length_of_rental ?? single(lengthRental.value),
		byProvider: !!includeProviders.value,
	}
}

/** The decisions of one cell, only with a pass open and the switch on (CU-869fmm949, criteria 1, 3). */
export default function useCellDecisions(priceData) {
	if (!repricingPass.value || !passDecisions.value?.cells) return { decisions: [], notPriced: 0, on: false }
	const cell = cellDecisions(decisionsIndex(), cellPlace(priceData))
	return { ...cell, on: !!showPassDecisions.value }
}
